import * as React from 'react';

interface IListHeaderSearchProps {
  placeholder?: string;
  onSearch?: (search: string) => void;
  serachTerm?: string;
  additionalClass?: string;
}

const ListHeaderSearch: React.FunctionComponent<IListHeaderSearchProps> = React.memo(
  (props) => {
    const [search, setSearch] = React.useState(props.serachTerm || '');

    React.useEffect(() => {
      setSearch(props.serachTerm || '');
    }, [props.serachTerm]);

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      props.onSearch?.(search);
    };

    return (
      <div className={`filter-search ${props.additionalClass ? props.additionalClass: ''}`}>
        <form onSubmit={onSubmit}>
          <div className='input-group'>
            <input
              type='text'
              className='form-control border-0 pr-0'
              placeholder={props.placeholder || 'Search'}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search.length > 0 && (
              <span
                className='btn btn-link border-0 bg-transparent px-2 py-0 btn-close position-relative'
                onClick={() => {
                  setSearch('');
                  props.onSearch?.('');
                }}
              >
                <i className='icon-close position-absolute align-xy-center font-weight-bold font-xxxs text-dark'></i>
              </span>
            )}
            <div className='input-group-append w-auto'>
              <span
                onClick={() => props.onSearch?.(search)}
                className='form-control-search btn btn-link border-0 bg-transparent px-3 py-0'
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
);

export default ListHeaderSearch;
